
import { ApiURLs, imageBaseUrls } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage, } from "../../../services/api";
import { hideAddMakeModal } from "./makeModalDispatcher";



export const addMakeRequest = (data, parent_name, make_name,pageSize=10,page=1,searchTerm="") => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "ADD_MAKE_REQUEST" });
    try {


      var makeResponse = (data.id) ? await updateData(data, `${ApiURLs.VEHICLE_MAKE}/${data.id}`) : await postData(data, ApiURLs.VEHICLE_MAKE);
      if (makeResponse.status === 1) {
        dispatch({ "type": "ADD_MAKE_SUCCESS" });
        dispatch(hideAddMakeModal());
        dispatch(makeLisitingRequest(page, pageSize, parent_name, make_name,searchTerm));
      } else {
        dispatch({ "type": "ADD_MAKE_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_MAKE_FAILED" });

    }
  };
};

export const deleteMake = (id, parent_name, make_name,pageSize=10,page=1,searchTerm="") => {
  return async (dispatch) => {

    // dispatch();
    dispatch({ "type": "ADD_MAKE_REQUEST" });
    try {


      var makeResponse = await deleteData(`${ApiURLs.VEHICLE_MAKE}/${id}`);
      if (makeResponse.status === 1) {
        dispatch({ "type": "ADD_MAKE_SUCCESS" });
        dispatch(makeLisitingRequest(page, pageSize, parent_name, make_name,searchTerm));
      } else {
        dispatch({ "type": "ADD_MAKE_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "ADD_MAKE_FAILED" });
    }
  };
};

export const syncVehiclesData = (parent_name, make_name,pageSize=10,page=1,searchTerm="") => {
  return async (dispatch) => {
    try {

      // data.csvUrl = 'https://development-api.listit.im/assets/images/make/1753967401481-df_VEH0120_GB.csv';

      const url = `${ApiURLs.SYNC_VEHICLES_DATA}`;
      var modelRes = await fetchData(url);

      if (modelRes.status === 1) {
      }
      dispatch(makeLisitingRequest(page, pageSize, parent_name, make_name,searchTerm));
    } catch (error) {
      console.log(`Error while syncing : ${error}`);
    }
  };
};

export const makeLisitingRequest = (page = 1, pageSize = 10, parent_name, make_name,  searchTerm = "") => {

  console.log("DGAAHAGHAGHGAHA:::::::::", parent_name, make_name);
  return async (dispatch) => {

    if (parent_name !== "__ROOT__") {
      let url1 = `${ApiURLs.VEHICLE_MAKE}?offset=${page}&limit=1&name=${encodeURIComponent(parent_name)}`;

      if (make_name) {
        url1 += `&make_name=${encodeURIComponent(make_name)}`;
      }
      try {
        var makeResponse = await fetchData(url1);
        dispatch({ "type": "GOT_MAKE_DETAIL", "payload": makeResponse.data.result[0] });
        console.log("000000000000000000000", parent_name, makeResponse.data.result[0]);

      }
      catch (e) {
      }
    }
    else {
      if (parent_name === "__ROOT__") {
        dispatch({ "type": "GOT_MAKE_DETAIL", "payload": null });
      }

    }


    let url = `${ApiURLs.VEHICLE_MAKE}?offset=${page}&limit=${pageSize}&parent_name=${parent_name}&keyword=${searchTerm}`;

    if (make_name) {
      url += `&make_name=${encodeURIComponent(make_name)}`;
    }


    // wait untill the data not received so getData function take data and url part
    dispatch({ "type": "GET_MAKE_REQUEST" });
    try {
      var makeResData = await fetchData(url);
      console.log(`response when we try to login ${JSON.stringify(makeResData)}`)
      if (makeResData.status === 1) {
        dispatch({ "type": "GET_MAKE_REQUEST_SUCCESS", "payload": makeResData.data.result, "total": makeResData.data.total });

      } else {
        dispatch({ "type": "GET_MAKE_REQUEST_FAILED" });
      }
    } catch (error) {
      dispatch({ "type": "GET_MAKE_REQUEST_FAILED" });
      console.log(`error while try to login ${error}`)
    }
  }
};

export const getMakeListing = () => {

  return async (dispatch) => {
    const url = `${ApiURLs.VEHICLE_MAKE}`;
    try {
      var makeResData = await fetchData(url);
      console.log(`response when we try to get make ${JSON.stringify(makeResData)}`)
      if (makeResData.status === 1) {
        return makeResData.data.result;
      } else {
        return [];
      }
    } catch (error) {
      console.log(`error while try to make ${error}`)

      return [];
    }
  }
};

export const addBulkMakeModel = (parent_name, make_name, data,pageSize=10,page=1,searchTerm="") => {
  return async (dispatch) => {
    try {


      console.log("Add BULK DATA 1", {
        name: data.file.name,
        size: data.file.size,
        type: data.file.type,
        lastModified: data.file.lastModified,
      });


      if (data.file) {
        var uploadedFile = await uploadImage(
          ApiURLs.UPLOAD_IMAGE_OLD, "image",
          data.file,
          "make"
        );
        console.log(`Add BULK DATA   2 ${JSON.stringify(uploadedFile)}`)

        data.csvUrl = `${imageBaseUrls(uploadedFile.data.file.filename)}`
      }

      // data.csvUrl = 'https://development-api.listit.im/assets/images/make/1770375445993-make_model.csv';

      const url = `${ApiURLs.VEHICLE_MAKE_BULK}`;
      var modelRes = await postData(data, url);

      if (modelRes.status === 1) {
      }
      dispatch(makeLisitingRequest(page, pageSize, parent_name, make_name,searchTerm));
    } catch (error) {

      console.log(`Error while syncing : ${error}`);
    }
  };
};








